import axios from "axios"

export const getFolderTemplates = async (params = {}) => {
  return await axios.get("/controls/folder_template/", { params })
}

export const createFolderTemplate = async (payload = {}) => {
  return await axios.post(`/controls/folder_template/`, payload)
}

export const deleteFolderTemplate = async id => {
  return await axios.delete(`/controls/folder_template/${id}/`)
}

export const updateFolderTemplate = async (id, payload) => {
  return await axios.patch(`/controls/folder_template/${id}/`, payload)
}
